import axios from 'axios';

import { SERVICEBASEURL } from 'enums/serviceBaseUrls';
import { Optional } from 'functions/promiseExtensions';

export function callApi(id: string, putObject: Request): Promise<Optional<void>> {
	const url: string = `${SERVICEBASEURL.BACKEND}/Allergen/${id}`;
	return axios.put(url, putObject).toOptionalVoid();
}

export interface Request {
	negativeIconSvgId: string | null;
	positiveIconSvgId: string | null;
	mayContainIconSvgId: string | null;
	display: boolean;
	positiveNameTranslations: {
		[key: string]: string;
	};
	negativeNameTranslations: {
		[key: string]: string;
	};
	mayContainNameTranslations: {
		[key: string]: string;
	};
}
